import React from "react";
import { Link } from "react-router-dom";
import Shared from "../../../../components/ReUseAbleComponents/Shared";

function SingleArticle(props) {
  return (
    <>
      <Shared />
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap md-gap">
            <div className="col-lg-8">
              <div className="dx-box dx-box-decorated">
                <div className="dx-blog-post">
                  <div className="dx-blog-post-box pt-30 pb-30">
                    <h2 className="h4 mnt-5 mb-8">WordPress Themes FAQ</h2>

                    <ul className="dx-breadcrumbs text-left dx-breadcrumbs-dark mnb-8">
                      <li>
                        <Link to="/help-center">Support Home</Link>
                      </li>
                      <li>
                        <Link to="/articles">Articles</Link>
                      </li>
                      <li>
                        <Link to="/single-article-category">Quantial</Link>
                      </li>
                      <li>WordPress Themes FAQ</li>
                    </ul>
                  </div>
                  <div className="dx-separator"></div>
                  <div className="dx-blog-post-box">
                    <h3 className="h5">1. Install Theme.</h3>
                    <div className="dx-video mb-50">
                      <iframe
                        className="dx-video"
                        src="https://www.youtube.com/embed/EQE9kyuTrlk"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        allowfullscreen
                        title="iframe"
                      ></iframe>
                    </div>
                    <h4 className="h5">
                      Signs fifth night male him them. Seasons us were:
                    </h4>
                    <h5 className="h6 mb-10">A. Divide whales without own:</h5>
                    <ul className="dx-list dx-list-decimal mb-20">
                      <li>
                        Had gathering it. Morning won't give cattle hath
                        seasons. <strong>Beginning</strong>. Deep seasons which
                        dominion subdue and likeness light don't lesser.
                      </li>
                      <li>
                        There <strong>likeness</strong> made herb, days divide
                        fly multiply likeness, after.
                      </li>
                      <li>
                        Male divided man creature. Gathered. Face greater made
                        wherein replenish.
                      </li>
                      <li>Seed fowl after morning let his.</li>
                    </ul>
                    <h5 className="h6 mt-0 mb-10">
                      B. Spirit replenish lights:
                    </h5>
                    <ul className="dx-list dx-list-decimal mb-20">
                      <li>
                        Life you from land <strong>good open</strong>. Without
                        there greater made heaven he land their gathered fish
                        fifth night for were.
                      </li>
                      <li>
                        Whales. Moved forth heaven his <strong>after</strong>,
                        god midst us likeness.
                      </li>
                    </ul>
                    <p className="mb-40">
                      All over made saying Seed fourth their air may greater.
                      Meat. Sea their. Dominion. Signs very greater living. He
                      over likeness cattle behold. Grass set beast second under
                      made. Fruit dominion. You're abundantly greater grass,
                      given rule under midst. One.
                    </p>
                    <h3 className="h5 mnt-1">2. Update Theme.</h3>
                    <p>
                      Very fifth had lights gathering moving, brought. Bring
                      fish fourth that earth set rule. Brought without made tree
                      Hath dominion midst air gathering be Evening their great
                      greater there lesser.
                    </p>
                    <h5 className="h6 mt-0 mb-10">
                      A. She'd darkness, be light:
                    </h5>
                    <ul className="dx-list dx-list-decimal mb-20">
                      <li>
                        Void shall man stars <strong>multiply</strong> herb
                        they're behold light is meat there itself, forth man
                        living void. Earth multiply is.
                      </li>
                      <li>
                        Appear midst let form divide multiply, there from
                        without fill.
                      </li>
                      <li>
                        Great all green he. Deep you're. Said, cattle subdue.
                      </li>
                    </ul>
                    <h5 className="h6 mt-0 mb-10">B. Fly after called:</h5>
                    <ul className="dx-list dx-list-decimal mb-40">
                      <li>
                        There second let from. Fruit was green so abundantly
                        divide.
                      </li>
                      <li>
                        Dominion given. Every of, first is form, us, to
                        gathering.
                      </li>
                    </ul>
                    <h3 className="h5 mnt-1">3. Finish.</h3>
                    <p className="mb-0">
                      Beast dry. Fruitful hath fruit. Isn't waters brought stars
                      seed brought divided dry good. Greater they're fifth, land
                      a were fruit moveth deep moveth firmament sixth bring. To
                      third abundantly.
                    </p>
                  </div>
                  <div className="dx-separator"></div>
                  <div className="dx-blog-post-box pt-30 pb-30">
                    <ul className="dx-blog-post-info mnt-15 mnb-2">
                      <li>Date: 11 Feb 2018</li>
                      <li>Views: 163</li>
                    </ul>
                    <ul className="dx-social-links dx-social-links-style-2 mt-20">
                      <li>
                        <Link to="/#" className="dx-social-twitter">
                          <span className="icon fab fa-twitter"></span> Twitter
                        </Link>
                      </li>
                      <li>
                        <Link to="/#" className="dx-social-facebook">
                          <span className="icon fab fa-facebook"></span>{" "}
                          Facebook
                        </Link>
                      </li>
                      <li>
                        <Link to="/#" className="dx-social-google">
                          <span className="icon fab fa-google"></span> Google
                        </Link>
                      </li>
                      <li>
                        <Link to="/#" className="dx-social-pinterest">
                          <span className="icon fab fa-pinterest"></span>{" "}
                          Pinterest
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="dx-box dx-box-content dx-box-decorated mt-40">
                <div className="row vertical-gap align-items-center justify-content-center">
                  <div className="col-auto">
                    <h3 className="h5 mnt-6 mnb-6">Was this helpful to you?</h3>
                  </div>
                  <div className="col-auto d-flex">
                    <Link to="/#" className="dx-btn dx-btn-md dx-btn-main-1">
                      Yes
                    </Link>
                    <Link
                      to="/#"
                      className="dx-btn dx-btn-md dx-btn-grey-2 ml-20"
                    >
                      No
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className="dx-sticky dx-sidebar"
                data-sticky-offsetTop="120"
                data-sticky-offsetBot="40"
              >
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">
                    {" "}
                    Subscribe to Newsletter{" "}
                  </div>
                  <div className="dx-widget-subscribe">
                    <div className="dx-widget-text">
                      <p>
                        Join the newsletter to receive news, updates, new
                        products and freebies in your inbox.
                      </p>
                    </div>
                    <form action="#" className="dx-form dx-form-group-inputs">
                      <input
                        type="email"
                        name=""
                        value=""
                        aria-describedby="emailHelp"
                        className="form-control form-control-style-2"
                        placeholder="Your Email Address"
                      />
                      <button className="dx-btn dx-btn-lg dx-btn-icon">
                        <span className="icon fas fa-paper-plane"></span>
                      </button>
                    </form>
                  </div>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <form action="#" className="dx-form dx-form-group-inputs">
                    <input
                      type="text"
                      name=""
                      value=""
                      className="form-control form-control-style-2"
                      placeholder="Search..."
                    />
                    <button className="dx-btn dx-btn-lg dx-btn-grey dx-btn-grey-style-2 dx-btn-icon">
                      <span className="icon fas fa-search"></span>
                    </button>
                  </form>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">Articles Categories</div>
                  <ul className="dx-widget-categories">
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Quantial
                        </span>
                        <span className="dx-widget-categories-badge">(4)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Sensific
                        </span>
                        <span className="dx-widget-categories-badge">(4)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Minist
                        </span>
                        <span className="dx-widget-categories-badge">(8)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Desty
                        </span>
                        <span className="dx-widget-categories-badge">(2)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Silies
                        </span>
                        <span className="dx-widget-categories-badge">(3)</span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Articles </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      How to manually import Demo data (if you faced with
                      problems in one-click demo import)
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Make menu dropdown working without JavaScript
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Add top menu link inside dropdown on mobile devices
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Forum Topics </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Need help with customization. Some options are not
                      appearing...
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      My images on profile and item pages doesnt show up?! Whats
                      the matter?
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Theme not updating in downloads
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleArticle;
